import { IDataGrouped } from "@app/interfaces/idata-grouped";

export const TIC_NAME: Array<{ id: number, name: string, type: string }> = [
    { id: 1, name: "Excel", type: "Básicas" },
    { id: 2, name: "Google Meet", type: "Básicas" },
    { id: 3, name: "Power Point", type: "Básicas" },
    { id: 4, name: "Teams", type: "Básicas" },
    { id: 5, name: "Word", type: "Básicas" },
    { id: 6, name: "Zoom", type: "Básicas" },
    { id: 7, name: "Canvas", type: "Learning Management System(LMS)" },
    { id: 8, name: "Google Classroom", type: "Learning Management System(LMS)" },
    { id: 9, name: "Adobe Creative Cloud", type: "Diseño y Audiovisual" },
    { id: 10, name: "Canva", type: "Diseño y Audiovisual" },
    { id: 11, name: "Figma", type: "Diseño y Audiovisual" },
    { id: 12, name: "Illustrator", type: "Diseño y Audiovisual" },
    { id: 13, name: "Indesign", type: "Diseño y Audiovisual" },
    { id: 14, name: "Loom", type: "Diseño y Audiovisual" },
    { id: 15, name: "Mindmup", type: "Diseño y Audiovisual" },
    { id: 16, name: "Miro", type: "Diseño y Audiovisual" },
    { id: 17, name: "Photoshop", type: "Diseño y Audiovisual" },
    { id: 18, name: "Prezi", type: "Diseño y Audiovisual" },
    { id: 19, name: "Sketch up", type: "Diseño y Audiovisual" },
    { id: 20, name: "Tinkercad", type: "Diseño y Audiovisual" },
    { id: 21, name: "WeVideo", type: "Diseño y Audiovisual" },
    { id: 22, name: "Book Creator", type: "Enseñanza Digital" },
    { id: 23, name: "Educandy", type: "Enseñanza Digital" },
    { id: 24, name: "Genially", type: "Enseñanza Digital" },
    { id: 25, name: "Jamboard", type: "Enseñanza Digital" },
    { id: 26, name: "Kahoot", type: "Enseñanza Digital" },
    { id: 27, name: "Kialo", type: "Enseñanza Digital" },
    { id: 28, name: "Lirmi", type: "Enseñanza Digital" },
    { id: 29, name: "Mentimeter", type: "Enseñanza Digital" },
    { id: 30, name: "Nearpod", type: "Enseñanza Digital" },
    { id: 31, name: "Padlet", type: "Enseñanza Digital" },
    { id: 32, name: "Pear deck", type: "Enseñanza Digital" },
    { id: 33, name: "Popplet", type: "Enseñanza Digital" },
    { id: 34, name: "Quizlet", type: "Enseñanza Digital" },
    { id: 35, name: "Socratico", type: "Enseñanza Digital" },
    { id: 36, name: "Storyboard That!", type: "Enseñanza Digital" },
    { id: 37, name: "Arduino", type: "Programación y Robótica" },
    { id: 38, name: "C++", type: "Programación y Robótica" },
    { id: 39, name: "Java", type: "Programación y Robótica" },
    { id: 40, name: "JavaScript", type: "Programación y Robótica" },
    { id: 41, name: "Lego ev3", type: "Programación y Robótica" },
    { id: 42, name: "Lego WeDo", type: "Programación y Robótica" },
    { id: 43, name: "Microbit", type: "Programación y Robótica" },
    { id: 44, name: "PHP", type: "Programación y Robótica" },
    { id: 45, name: "Phyton", type: "Programación y Robótica" },
    { id: 46, name: "Raspberry pi", type: "Programación y Robótica" },
    { id: 47, name: "Ruby", type: "Programación y Robótica" },
    { id: 48, name: "Scratch", type: "Programación y Robótica" },
]

const ticGroupArray = TIC_NAME.reduce(function (obj, item) {
    obj[item.type] = obj[item.type] || [];
    obj[item.type].push({ id: item.id, child: item.name });
    return obj;
}, {});

export const TIC_NAME_GROUPED: Array<IDataGrouped> = Object.keys(ticGroupArray).map(function (key) {
    return { parent: key, items: ticGroupArray[key] };
});




// revisar: hacer merge con el listado anterior
export const TIC_NAME_NEW_CATEGORY: Array<{ id: number, name: string, type: string }> = [
    { id: 101, name: 'PAES', type: 'Experiencia en preparación de pruebas', },
    { id: 102, name: 'SIMCE', type: 'Experiencia en preparación de pruebas', },
    { id: 103, name: 'Bachillerato Internacional (IB)', type: 'Experiencia en preparación de pruebas', },
    { id: 114, name: 'Método Singapur', type: 'Metodologías de Enseñanza que dominas', },
    { id: 166, name: 'Método Montessori', type: 'Metodologías de Enseñanza que dominas', },
    { id: 115, name: 'Aprendizaje basado en Proyectos (ABP)', type: 'Metodologías de Enseñanza que dominas', },
    { id: 116, name: 'Flipped Classroom (Aula Invertida)', type: 'Metodologías de Enseñanza que dominas', },
    { id: 117, name: 'Aprendizaje Cooperativo', type: 'Metodologías de Enseñanza que dominas', },
    { id: 118, name: 'Gamificación', type: 'Metodologías de Enseñanza que dominas', },
    { id: 119, name: 'Design Thinking', type: 'Metodologías de Enseñanza que dominas', },
    { id: 120, name: 'Aprendizaje Basado en el Pensamiento', type: 'Metodologías de Enseñanza que dominas', },
    { id: 121, name: 'Aprendizaje Basado en Problemas', type: 'Metodologías de Enseñanza que dominas', },
    { id: 122, name: 'Aprendizaje Basado en Competencias', type: 'Metodologías de Enseñanza que dominas', },
    { id: 123, name: 'Ajedrez', type: 'Especialidades deportivas', },
    { id: 124, name: 'Atletismo', type: 'Especialidades deportivas', },
    { id: 125, name: 'Baloncesto', type: 'Especialidades deportivas', },
    { id: 126, name: 'Balonmano', type: 'Especialidades deportivas', },
    { id: 127, name: 'Entrenamiento Funcional', type: 'Especialidades deportivas', },
    { id: 128, name: 'Escalada', type: 'Especialidades deportivas', },
    { id: 129, name: 'Esgrima', type: 'Especialidades deportivas', },
    { id: 130, name: 'Fútbol', type: 'Especialidades deportivas', },
    { id: 131, name: 'Gimnasia (Artística / Rítmica)', type: 'Especialidades deportivas', },
    { id: 132, name: 'Hockey', type: 'Especialidades deportivas', },
    { id: 133, name: 'Karate', type: 'Especialidades deportivas', },
    { id: 134, name: 'Rugby', type: 'Especialidades deportivas', },
    { id: 135, name: 'Scout', type: 'Especialidades deportivas', },
    { id: 136, name: 'Tenis', type: 'Especialidades deportivas', },
    { id: 137, name: 'Tenis de mesa', type: 'Especialidades deportivas', },
    { id: 138, name: 'Vóleibol', type: 'Especialidades deportivas', },
    { id: 139, name: 'Yoga', type: 'Especialidades deportivas', },
    { id: 140, name: 'Zumba', type: 'Especialidades deportivas', },
    { id: 141, name: 'Acordeón', type: 'Especialidad musicales', },
    { id: 142, name: 'Bajo eléctrico', type: 'Especialidad musicales', },
    { id: 143, name: 'Batería y percusión', type: 'Especialidad musicales', },
    { id: 144, name: 'Clarinete', type: 'Especialidad musicales', },
    { id: 145, name: 'Coro', type: 'Especialidad musicales', },
    { id: 146, name: 'Cueca', type: 'Especialidad musicales', },
    { id: 147, name: 'Danza', type: 'Especialidad musicales', },
    { id: 148, name: 'Flauta traversa', type: 'Especialidad musicales', },
    { id: 149, name: 'Folclore', type: 'Especialidad musicales', },
    { id: 150, name: 'Guitarra', type: 'Especialidad musicales', },
    { id: 151, name: 'Guitarra Eléctrica', type: 'Especialidad musicales', },
    { id: 152, name: 'Piano', type: 'Especialidad musicales', },
    { id: 153, name: 'Saxofón', type: 'Especialidad musicales', },
    { id: 154, name: 'Trompeta', type: 'Especialidad musicales', },
    { id: 155, name: 'Ukelele', type: 'Especialidad musicales', },
    { id: 156, name: 'Viola', type: 'Especialidad musicales', },
    { id: 157, name: 'Violín', type: 'Especialidad musicales', },
    { id: 158, name: 'Violoncello', type: 'Especialidad musicales', },
    { id: 159, name: 'Ballet', type: 'Artísticas', },
    { id: 160, name: 'Cerámica', type: 'Artísticas', },
    { id: 161, name: 'Comics e Ilustraciones', type: 'Artísticas', },
    { id: 162, name: 'Fotografía', type: 'Artísticas', },
    { id: 163, name: 'Manualidades', type: 'Artísticas', },
    { id: 164, name: 'Pintura', type: 'Artísticas', },
    { id: 165, name: 'Teatro', type: 'Artísticas', }]

export const TIC_SPECIALTY_CATEGORY: Array<{ id: number, name: string, type: string }> = 
TIC_NAME_NEW_CATEGORY.filter(e => e.type === 'Especialidades deportivas' || e.type === 'Especialidad musicales' || e.type === 'Artísticas');

const ticNewGroupArray = TIC_NAME_NEW_CATEGORY.reduce(function (obj, item) {
    obj[item.type] = obj[item.type] || [];
    obj[item.type].push({ id: item.id, child: item.name });
    return obj;
}, {});

const ticNewGroupArraySpecialty = TIC_SPECIALTY_CATEGORY.reduce(function (obj, item) {
    obj[item.type] = obj[item.type] || [];
    obj[item.type].push({ id: item.id, child: item.name });
    return obj;
}, {});

export const TIC_NAME_NEW_CATEGORY_GROUPED: Array<IDataGrouped> = Object.keys(ticNewGroupArray).map(function (key) {
    return { parent: key, items: ticNewGroupArray[key] };
});

export const TIC_SPECIALTY_CATEGORY_GROUPED: Array<IDataGrouped> = Object.keys(ticNewGroupArraySpecialty).map(function (key) {
    return { parent: key, items: ticNewGroupArraySpecialty[key] };
});



